import { NgModule } from '@angular/core';
import { CurrencyFormatDirective } from './currency-format.directive';

@NgModule({
  declarations: [CurrencyFormatDirective],
  exports: [CurrencyFormatDirective] // Export it so it can be used in other modules
})
export class CurrencyFormetDirectivesModule { }